<template>
  <div>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button class="button_back" @click="goBack('userForm')">
          <ion-icon name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>Record a shift</ion-title>
    </ion-toolbar>

    <div class="main_wrapper main_wrapper--custom ion-padding">
      <div class="container">
      <el-form
        class="full_page"
        :model="formsData.userForm"
        :rules="formsData.userForm.rules"
        :ref="(el) => (formsData.userForm.ref = el)"
        :label-position="'top'"
        @submit.prevent="submit('userForm')"
      >

      <div class="auth-header">
          <div class="auth-heading">
            <h1>Hourly Payment Range</h1>
            <p class="auth-subtext" v-if="isAustralia">(Excluding Super)</p>
          </div>
          <div class="brand-icon">
                    <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none"/>
                </div>
        </div>
      <el-form-item prop="payRate" :required="true">
          <div class="el-input el-input--suffix">
            <input
              type="tel"
              class="input_currency el-input__inner"
              :ref="(el) => (formsData.userForm.payRate.ref = el)"
              :value="formsData.userForm.payRate.value"
              :placeholder="'0.00'"
              v-imask="{ mask: Number, min: 0, max: 999.99, scale: 2, padFractionalZeros: true, normalizeZeros: true, radix: '.' }"
              @accept="onFormMaskAccept($event, 'userForm', 'payRate')"
              @blur="checkFormValidation('userForm', true, 'payRate')"
              @change="checkFormValidation('userForm', false, 'payRate')"
              @keyup="formsData.userForm.payRate.value = $event.target.value"
            />
            <span class="el-input__suffix" v-if="isAustralia">AUD</span>
              <span class="el-input__suffix fnt-size" v-else>USD</span>
          </div>
        </el-form-item>
      
      <el-form-item label="Shift Notes" prop="shiftNotes" :required="false">
          <el-input
            type="textarea"
            class="shiftNotes"
            v-model="formsData.userForm.shiftNotes.value"
            placeholder="Enter your notes"
          ></el-input>
        </el-form-item>

      <div class="form_text page_padding_top">
        <div class="title">
          {{ $filters.systemLocumName(true, true) }} Details
        </div>
        <div class="text_note">
          Please provide information on {{ $filters.systemLocumName(false, false) }}. We will email them the details of the shift and get them to accept the shift terms for compliance.
        </div>
      </div>
      <el-form-item label="First Name" prop="firstName" :required="true">
        <el-input
          v-model="formsData.userForm.firstName.value"
          autocomplete="off"
          placeholder="First Name"
          :maxlength="20"
          @keyup="
            formsData.userForm.firstName.value = $event.target.value
          "
        ></el-input>
      </el-form-item>
      <el-form-item label="Last Name" prop="lastName" :required="true">
        <el-input
          v-model="formsData.userForm.lastName.value"
          autocomplete="off"
          placeholder="Last Name"
          :maxlength="20"
          @keyup="formsData.userForm.lastName.value = $event.target.value"
        ></el-input>
      </el-form-item>
      <el-form-item label="Email" prop="email" :required="true">
          <el-input
          type="email"
          v-model="formsData.userForm.email.value"
          placeholder="email@gmail.com"
          ></el-input>
      </el-form-item>
      <el-form-item
            label="Phone Number"
            prop="mobileNumber"
            :required="true"
            class="collapsing-dropdown-scroll-off"
          >
          <div class="el-input">
            <vue-tel-input
              class="el-input__inner"
              :value="formsData.userForm.mobileNumber.valueFormatted"
              v-model="formsData.userForm.mobileNumber.value"
              @input="onPhoneInput"
              :preferredCountries="[$filters.vueTelInput()]"
              :autoDefaultCountry="false"
              v-bind="{ mode: 'international' }"
            ></vue-tel-input>
          </div>
        </el-form-item>
        <el-form-item label="Additional Terms and Conditions" prop="additionalTermCondition" :required="false">
          <el-input
            type="textarea"
            class="additional_term_condition"
            v-model="formsData.userForm.additionalTermCondition.value"
            placeholder="Enter your notes"
          ></el-input>
        </el-form-item>
        <el-form-item :required="false">
          <el-checkbox v-model="formsData.userForm.requestAphraIns.value"
            > Request <span v-if="isAustralia">AHPRA and</span> Insurance forms
          </el-checkbox>
        </el-form-item>
        <div class="form_text page_padding_top">
          <div class="title">
            Upload a Policy
          </div>
          <div class="text_note">
            This pharmacy contract will take precedence over the group pharmacy contract.
          </div>
        </div>
    
        <el-form-item :required="false" v-if="files==null">
          <el-upload
            class="uploader-support"
            :action="'upload'"
            accept="image/*,application/pdf"
            name="files"
            list-type="picture"
            :thumbnail-mode="true"
            :on-preview="cropperMethods.handlePreview"
            :limit="1"
            :on-exceed="cropperMethods.handleExceed"
            :drag="true"
            :on-change="cropperMethods.handleChange"
            :before-upload="cropperMethods.beforeAvatarUpload"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              Drop file here or <em>click to upload</em>
            </div>
            <template #file="{ file }">
              <div v-if="file.raw.type == 'application/pdf'" class="el-upload-list__item-body">
                  <img class="el-upload-list__item-body-thumbnail"
                      :src="require('@/assets/img/icons/pdf.svg')" />
                  <span class="mx-2" size="large">{{ file.name }}</span>
              </div>
              <div class="el-upload-list__item-body" v-else>
                  <img class="el-upload-list__item-body-thumbnail" :src="file.url" alt="" />
                  <span class="mx-2" size="large">{{ file.name }}</span>
              </div>
              <div class="el-upload-list__item-actions">
                  <button class="el-upload-list__item-actions-action"
                      @click.prevent="cropperMethods.handleRemove(file)">
                      <img :src="require('@/assets/img/icons/trash.svg')" />
                  </button>
              </div>
          </template>
          </el-upload>
        </el-form-item>

      </el-form>
      <div class="preview_square" v-if="files">
        <div class="el-upload-list">
          <div class="el-upload-list__item">
            <div class="thumbnail_img el-upload-list--picture-card">
              <div v-if="files.extension == 'pdf'">
                <span class="locumate_icons locumate_icon-picture"></span>
              </div>
              <div v-else>
                <img
                class="el-upload-list__item-thumbnail"
                :src="files.url"
                alt=""
              />
              </div>
            
              <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-preview"
                  @click="certPreviewModalOpen(files)"
                >
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span
                  class="el-upload-list__item-delete"
                  @click="fileDelete()"
                >
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <el-button
      class="primary w-full mt-auto"
          @click="submit('userForm')"
          :disabled="formsData.userForm.disabled"
        >
          <span>Send</span>
        </el-button>
    </div>
    </div>
    <cert-preview-modal
    :modalName="'certPreviewModal'"
    :options="certPreviewModal"
  />
  </div>

  <div class="el_dialog_wraper">
            <el-drawer :direction="'btt'" class="success-prompt" custom-class="success-prompt" :destroy-on-close="true" :append-to-body="true" v-model="showJobApplicationPopupMessage" title="Guest Shift Recorded" width="30%"
                @closed="redirectClose">
                <div class="message text-center mt-3">
                    
                    <div class="col-right" v-if="drawerContent.status == 'accept'">
                        <svg width="150" height="150" viewBox="0 0 309 309" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="154.5" cy="154.5" r="153.25" stroke="#009F98" stroke-width="1.5"
                            stroke-dasharray="3 5" />
                        <circle cx="154.5" cy="154.5" r="137.5" fill="white" />
                        <path
                            d="M223.733 140.046L217.067 134.952C217.933 131.869 218.667 129.256 219.333 126.977C222 117.996 223.467 113.037 219.8 107.944C216.133 102.85 211.133 102.649 201.667 102.381H193.4C192.267 99.4321 191.4 96.8184 190.6 94.6067C187.533 85.7603 185.8 81.203 179.8 78.9243C173.8 76.6457 169.6 79.8626 161.867 85.2241L155.2 89.8484L148.533 85.3581C141.667 79.9296 136.6 76.5787 130.533 78.5892C124.467 80.5998 122.867 85.2911 119.733 94.2046C118.933 96.4163 118 99.03 116.933 102.046L108.333 102.314C99 102.314 93.8667 102.649 90.2 107.742C86.5333 112.836 88.3333 117.795 90.8667 126.843C91.5333 129.121 92.3333 131.735 93.1333 134.818L86.4667 139.912C79.2 145.541 75 148.691 75 155.058C75 161.425 79.0667 164.507 86.4667 170.204L93.1333 175.298C92.3333 178.38 91.5333 180.994 90.8667 183.273C88.2 192.253 86.7333 197.213 90.4 202.306C94.0667 207.4 99.2667 207.534 108.533 207.802H116.733C117.867 210.751 118.733 213.364 119.533 215.576C122.667 224.422 124.333 228.98 130.333 231.258C136.333 233.537 140.533 230.32 148.267 224.959L154.933 220.334L161.6 224.824C165.712 228.443 170.787 230.772 176.2 231.526C177.402 231.514 178.595 231.31 179.733 230.923C185.733 228.98 187.4 224.221 190.533 215.308C191.333 213.096 192.2 210.482 193.333 207.534H201.6C210.933 207.534 216.067 207.199 219.733 202.038C223.4 196.878 222 191.985 219.333 183.005C218.667 180.726 217.867 178.112 217.067 175.029L223.733 169.936C231.067 164.641 235 161.76 235 155.058C235 148.356 231.067 145.742 223.733 140.046Z"
                            fill="#009F98" />
                        <path
                            d="M144.133 190.309C143.232 190.271 142.348 190.05 141.534 189.658C140.721 189.266 139.994 188.713 139.4 188.031L119.733 165.981C118.557 164.648 117.957 162.9 118.063 161.122C118.169 159.343 118.974 157.68 120.3 156.498C121.626 155.316 123.365 154.712 125.134 154.819C126.903 154.926 128.557 155.735 129.733 157.068L144.533 173.89L186.733 132.606C187.341 131.914 188.085 131.356 188.917 130.967C189.749 130.578 190.653 130.366 191.571 130.344C192.488 130.322 193.401 130.491 194.251 130.84C195.101 131.189 195.87 131.711 196.509 132.372C197.149 133.034 197.646 133.822 197.969 134.686C198.292 135.55 198.434 136.471 198.387 137.393C198.339 138.315 198.102 139.216 197.691 140.042C197.281 140.867 196.705 141.599 196 142.19L148.8 188.567C147.526 189.732 145.854 190.356 144.133 190.309Z"
                            fill="white" />
                    </svg>
                    </div>
                    <div class="col-right" v-else>
                      <svg width="150" height="150" viewBox="0 0 309 309" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="154.5" cy="154.5" r="153.25" stroke="#009F98" stroke-width="1.5" stroke-dasharray="3 5"/>
                        <circle cx="154.5" cy="154.5" r="137.5" fill="white"/>
                        <path d="M223.733 140.046L217.067 134.952C217.933 131.869 218.667 129.256 219.333 126.977C222 117.996 223.467 113.037 219.8 107.944C216.133 102.85 211.133 102.649 201.667 102.381H193.4C192.267 99.4321 191.4 96.8184 190.6 94.6067C187.533 85.7603 185.8 81.203 179.8 78.9243C173.8 76.6457 169.6 79.8626 161.867 85.2241L155.2 89.8484L148.533 85.3581C141.667 79.9296 136.6 76.5787 130.533 78.5892C124.467 80.5998 122.867 85.2911 119.733 94.2046C118.933 96.4163 118 99.03 116.933 102.046L108.333 102.314C99 102.314 93.8667 102.649 90.2 107.742C86.5333 112.836 88.3333 117.795 90.8667 126.843C91.5333 129.121 92.3333 131.735 93.1333 134.818L86.4667 139.912C79.2 145.541 75 148.691 75 155.058C75 161.425 79.0667 164.507 86.4667 170.204L93.1333 175.297C92.3333 178.38 91.5333 180.994 90.8667 183.273C88.2 192.253 86.7333 197.213 90.4 202.306C94.0667 207.4 99.2667 207.534 108.533 207.802H116.733C117.867 210.751 118.733 213.364 119.533 215.576C122.667 224.422 124.333 228.98 130.333 231.258C136.333 233.537 140.533 230.32 148.267 224.959L154.933 220.334L161.6 224.824C165.712 228.443 170.787 230.772 176.2 231.526C177.402 231.514 178.595 231.31 179.733 230.923C185.733 228.98 187.4 224.221 190.533 215.308C191.333 213.096 192.2 210.482 193.333 207.534H201.6C210.933 207.534 216.067 207.198 219.733 202.038C223.4 196.878 222 191.985 219.333 183.005C218.667 180.726 217.867 178.112 217.067 175.029L223.733 169.936C231.067 164.641 235 161.76 235 155.058C235 148.356 231.067 145.742 223.733 140.046Z" fill="#E34457"/>
                        <path d="M180.358 180.34C182.547 178.152 182.547 174.531 180.358 172.343L163 154.991L180.358 137.638C182.547 135.45 182.547 131.829 180.358 129.641C178.17 127.453 174.547 127.453 172.358 129.641L155 146.993L137.642 129.641C135.453 127.453 131.83 127.453 129.642 129.641C127.453 131.829 127.453 135.45 129.642 137.638L147 154.991L129.642 172.343C127.453 174.531 127.453 178.152 129.642 180.34C130.774 181.472 132.208 182 133.642 182C135.075 182 136.509 181.472 137.642 180.34L155 162.988L172.358 180.34C173.491 181.472 174.925 182 176.358 182C177.792 182 179.226 181.472 180.358 180.34Z" fill="white"/>
                      </svg>


                    </div>
                    <div class="col-right">
                        <p class="header">{{ drawerContent.heading }}</p>

                    </div>
                    <div class="col-right">
                        <p>{{ drawerContent.statusMessage }}</p>

                    </div>
                </div>

                    <span class="dialog-footer w-100">
                        <el-button @click="redirectClose" type="primary">Close</el-button>
                    </span>
            </el-drawer>
        </div>
</template>

<script>
import { ElMessage, ElMessageBox } from "@/components/Vendor/Element";
import { onMounted, inject,defineAsyncComponent,ref} from "vue";
import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
import formValidate from "@/hooks/form/validate/validate";
addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import {
  IonToolbar,
  IonButton,
  IonButtons,
  IonIcon,
  IonTitle,
} from "@ionic/vue";

import { useStore } from "vuex";
import {
  useRouter,
  // useRoute
} from "vue-router";
import formHooks from "@/hooks/form/form";
import IMaskDirective from "@/directives/vue-imask/directive";
import IMask from "imask/esm/imask";
import formMasks from "@/hooks/form/mask/mask";
import { CertPreviewModal } from "@/modals/modals";

import FileHelpers from "@/helpers/file/file";
import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';
import SvgIcon from '@/components/Svg/SvgIcon.vue'; 

const VueTelInput = defineAsyncComponent(() =>
  import("@/components/Vendor/vue-tel-input/components/vue-tel-input.vue")
);

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    IonTitle,
    VueTelInput,
    SvgIcon,
    "cert-preview-modal": CertPreviewModal,
  },
  directives: {
    imask: IMaskDirective,
  },
  setup() {
    const $store = useStore();
    const $router = useRouter();
    const setPageClassGlobal = inject("setPageClassGlobal");
    const fileHelpers = new FileHelpers();
    const jobCreatePageData = $store.getters.getGuestShiftRecordCreatePageData;
    console.log("all guest shift information",jobCreatePageData);
    const userData = $store.getters.GET_USER_DATA;
    const termsCondititon = userData.termsAndCondition ? userData.termsAndCondition : "";
    const payRate = jobCreatePageData.payRate;
    let dialogVisible = true;
    const $modals = inject("$modals");
    const isAustralia = isAustraliaRegion();
    const showJobApplicationPopupMessage = ref(false);
    const drawerContent = ref({
      title: 'Invitation',
      heading: '',
      statusMessage: '',
      status:''
    });
    const certPreviewModal = ref({
      name: "certPrev",
      file: [],
    });
    const certPreviewModalOpen = (files) => {
      // const myFiles =  {url: files};
      if(files.extension == 'pdf'){
        window.open(files.url, "_blank");
      }else{
        certPreviewModal.value.file = files;
        $modals.open("certPreviewModal", {
        file: files,
      });
      }
    };
   
    const files = ref(userData.groupContract);

    const formsDataArray = {
      userForm: {
        payRate: {
          value:payRate
              ? IMask.createMask(formMasks.rate).resolve(payRate)
              : "",
          mask: formMasks.payRate,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "payRate",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        shiftNotes: {
          value: jobCreatePageData.shiftNotes
            ? jobCreatePageData.shiftNotes
            : "",
        },
        firstName: {
          value: jobCreatePageData.firstName ? jobCreatePageData.firstName : "",
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "firstName",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        lastName: {
          value: jobCreatePageData.lastName ? jobCreatePageData.lastName : "",
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "lastName",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        email: {
          value: jobCreatePageData.email ? jobCreatePageData.email : "",
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "email",
                  callback,
                  setFormValidation
                );
              },
              trigger: ["blur", "enter"],
            },
          ],
        },
        mobileNumber: {
          ref: {},
          value: jobCreatePageData.mobileNumber ? jobCreatePageData.mobileNumber : "",
          valueFormatted: jobCreatePageData.mobileNumber ? jobCreatePageData.mobileNumber : "",
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "mobileNumber",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
          errors: null,
        },
        additionalTermCondition: {
          value: termsCondititon,
        },
        requestAphraIns: {
          value: jobCreatePageData.requestAphraIns ? jobCreatePageData.requestAphraIns : false,
        },
        files: {
          ref: null,
          value: [],
        },
      },
    };

    const onPhoneInput = (value, phoneObject) => {
      if (!value.target) {
        formsData.userForm.mobileNumber.ref.phoneObject = phoneObject;
      }
      formsData.userForm.mobileNumber.valueFormatted = value.target
        ? value.target.value
        : value;
      formsData.userForm.mobileNumber.value =
        formsData.userForm.mobileNumber.ref.phoneObject.number || null;

      checkFormValidation("userForm", false, "mobileNumber");
    };

    const cropperMethods = {
      beforeAvatarUpload(file) {
        const img = URL.createObjectURL(file.raw);
        console.log(img);
      },
      handleRemove(file) {
        formsData.userForm.files.splice(
          formsData.userForm.files.indexOf(file),
          1
        );
      },
      handleChange(file, files) {
        const type = fileHelpers.getFileType(file);
        console.log(type);
        if (type == "image" || type == "pdf") {
          formsData.userForm.files = files;
          formsData.userForm.files.value = files;
          checkFormValidation("userForm", true, "files");
        } else {
          files.pop();
          formsData.userForm.files.value = null;
          ElMessage({
            type: "error",
            message: `Certificate   must be JPG JPEG PNG JFIF or PDF format!`,
          });
        }
      },

      handlePreview(/*file*/) {},
      handleExceed(file, files) {
        console.log(file);
        ElMessage({
          type: "error",
          message: `You can download 5 certificate, you selected ${files.length} `,
        });
      },
    };

    const goBack = (formName) => {
      $store.dispatch("setGuestShiftRecordCreatePageData", getFormValues(formName));
      $router.push({
        name: "create_guest_shift_schedule",
      });
    };

    const submit = (formName) => {
      formsRefs[formName].value.validate((valid) => {
        if (valid) {
          console.log('FOMR VALUES:', getFormValues(formName));
          const canvas = formsData.userForm.files.value;
          const contract = new FormData();
          let counter = 0;
          if (canvas.length != 0) {
            canvas.map((item) => {
              console.log(item);
              contract.append(`file[${counter}]`,  item.raw );
              counter++;
            });
          }
         
          console.log(contract);
          (async () => {
              try {
                $store.dispatch("setGuestShiftRecordCreatePageData", getFormValues(formName));
                const createdShift = await $store.dispatch("ADD_GUEST_SHIFT");
                const shiftId = createdShift.data.guestLocum.id;
                contract.append(`id`,  shiftId );
                await $store.dispatch("UPLOAD_CONTRACT_SHIFT",contract);
                $store.dispatch("clearGuesstShiftRecordCreatePageData");
                // let massageText = {
                //                     title: 'Thank you!',
                //                     main: `The shift details have been emailed to ${formsData.userForm.firstName.value} ${formsData.userForm.lastName.value}. You will be notified as soon as they accept the shift.`
                //                 };
   
                // await ElMessageBox.confirm(massageText.main, massageText.title, {
                //                     showCancelButton: false,
                //                     confirmButtonText: 'Close',
                //                     confirmButtonClass: 'el-button--grey',
                //                     showClose: false,
                //                     type: 'success',
                //                     customClass: 'modal_success star',
                //                     callback: () => {
                //                       $router.push({
                //                         name: "search",
                //                       });
                //                     }
                //                 });

                  ElMessage.success("Invitation accepted successfully!!");
                  drawerContent.value = {
                    title: 'Thank you!',
                    heading: 'Thank you!',
                    statusMessage: `The shift details have been emailed to ${formsData.userForm.firstName.value} ${formsData.userForm.lastName.value}. You will be notified as soon as they accept/reject the shift.`,
                    status: 'accept'
                  };
                  showJobApplicationPopupMessage.value = true;
              } catch (error) {
                console.log(error);
                console.log("error submit!!");
              }
          })();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    };

    const redirectClose = () =>{
      showJobApplicationPopupMessage.value = false;
        $router.push({
          name: "search",
        });
    }

    onMounted(() => {
      setPageClassGlobal("global_job_create_page");
      setFormRefs();
      // checkFormValidation("userForm");
      checkFormValidation("userForm", false);
    });
    const activeName = "additional";

  
    // const onChangeNotes = (e) => {
    //   if (e == false) {
    //     formsData.userForm.notes.value = "";
    //   }
    // };
    const fileDelete = async () => {
      try {
        await ElMessageBox.confirm(
          `Are you sure you’d like to remove file ?`,
          "Remove file",
          {
            confirmButtonText: "Remove",
            cancelButtonText: "Cancel",
            confirmButtonClass: "el-button--red",
            cancelButtonClass: "el-button--grey",
            showClose: false,
          }
        );
        // await $store.dispatch("DELETE_USER_COVID_CERT", file);
        // files.value.splice(file, 1);
        files.value = null;
      } catch (error) {
        console.log(error);
      }
    };
   

    const {
      checkFormValidation,
      setFormValidation,
      getFormValues,
      setFormRefs,
      formsData,
      formsRefs,
    } = formHooks(formsDataArray);

    return {
      checkFormValidation,
      formsData,
      goBack,
      submit,
      activeName,
      onPhoneInput,
      cropperMethods,
      fileDelete,
      certPreviewModalOpen,
      certPreviewModal,
      files,
      dialogVisible,
      termsCondititon,
      isAustralia,
      showJobApplicationPopupMessage,
      drawerContent,
      redirectClose
    };
  },
};
</script>
